import { splitEvery } from 'ramda';
import { minusDays } from 'js/utils/date.util';
import { uniqueId } from 'js/utils/methods.util';
import { getDateForIms } from 'js/hooks/useFormatter/helpers';

import { CAROUSEL_MIN_ITEMS_PER_SLIDE, CAROUSEL_ITEM_MIN_WIDTH } from './constants';

export const parseTopWinners = (topWinners = []) => topWinners.map(item => ({
    ...item,
    id: uniqueId('top-winner-')
}));

export const getPeriodDates = (period = '1') => ({
    startDate: getDateForIms(minusDays(new Date(), Number(period))),
    endDate: getDateForIms(new Date())
});

// region Carousel

export const getSlides = (itemsPerSlide, topWinners) => {
    if (!topWinners.length) {
        return [];
    }

    const slides = splitEvery(itemsPerSlide, topWinners);
    const lastSlide = slides[slides.length - 1];

    if (lastSlide.length < itemsPerSlide) {
        const emptyItems = new Array(itemsPerSlide - lastSlide.length);

        emptyItems.fill(null);
        slides[slides.length - 1] = [...lastSlide, ...emptyItems];
    }

    return slides;
};

export const getRightMargin = (gameRef) => {
    let marginRight = parseFloat(getComputedStyle(gameRef).marginRight);

    if (marginRight !== 0) {
        return marginRight;
    }

    // for single element in slide possible margin won't be drawn hence we couldn't be able to calculate it
    const el = document.createElement('span');

    gameRef.parentElement.appendChild(el);
    marginRight = parseFloat(getComputedStyle(gameRef).marginRight);
    gameRef.parentElement.removeChild(el);

    return marginRight;
};

export const getTotalGamesCount = (containerEl, gameEl) => {
    const { paddingLeft, paddingRight } = getComputedStyle(containerEl);
    const gameMarginRight = getRightMargin(gameEl);
    const containerWidth = containerEl.offsetWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
    const minTotalGameWidth = CAROUSEL_ITEM_MIN_WIDTH + gameMarginRight;
    const gamesCount = Math.floor(containerWidth / minTotalGameWidth);

    return Math.max(gamesCount, CAROUSEL_MIN_ITEMS_PER_SLIDE);
};

// endregion

// region Table

export const getWinnersSelection = ({ rowsAmount, startIndex, allWinners }) => {
    const winners = [];
    const allWinnersLength = allWinners.length;
    const realSelectionLength = rowsAmount > allWinnersLength ? allWinnersLength : rowsAmount;

    for (let i = 0; i < realSelectionLength; i++) {
        const realIndex = startIndex + i >= allWinnersLength
            ? (startIndex + i) % allWinnersLength
            : startIndex + i;

        winners[i] = allWinners[realIndex];
    }

    return winners.reverse();
};

//  endregion
